import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import axios from "axios";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  margin: 0 auto;
  width: 100%;
  max-width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  overflow-y: auto;
`;

const Input = styled.input`
  padding: 12px;
  margin-bottom: 20px;
  width: 90%;
  font-size: 16px;
`;

const Button = styled.button`
  padding: 12px 24px;
  background-color: #00b900;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 80%;
  font-size: 18px;
  &:hover {
    background-color: #007700;
  }
`;

const Table = styled.table`
  width: 90%;
  max-width: 100%;
  margin-top: 50px;
  border-collapse: collapse;
  font-size: 12px;
  th,
  td {
    border: 1px solid #ddd;
    text-align: left;
    padding: 8px;
  }
  th {
    background-color: #f2f2f2;
  }
  overflow-x: auto;
`;

const loadingAnimation = keyframes`
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
`;

const LoadingBar = styled.div`
  width: 100%;
  height: 4px;
  background-color: #00b900;
  position: absolute;
  top: 0;
  left: -100%;
  animation: ${loadingAnimation} 1.5s infinite linear;
  display: ${(props) => (props.isLoading ? "block" : "none")};
`;

const Message = styled.div`
  color: red;
  margin: 10px;
  font-size: 16px;
  width: 90%;
  text-align: center;
`;

const Notice = styled.div`
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
  width: 90%;
  font-size: 14px;
  line-height: 1.5;
`;

const SearchForm = () => {
  const [amount, setAmount] = useState("");
  const [results, setResults] = useState([]);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.post(
        "https://api.h-and.world/esafe/double_check",
        { amount }
      );
      setResults(data.results);
      setMessage(data.messages);
    } catch (error) {
      console.error("Error fetching data:", error);
      setMessage("取得資料失敗，請稍後再試");
    } finally {
      setIsLoading(false);
    }
  };

  const translateStatus = (status) => {
    return status === "00" ? "成功" : "失敗";
  };

  return (
    <Container>
      <LoadingBar isLoading={isLoading} />
      <Notice>
        注意事項：
        <ol>
          <li>僅能以「刷卡金額」查詢交易紀錄</li>
          <li>30秒內無法重複查詢同樣的交易金額</li>
          <li>可查詢時間範圍：刷卡成功後20分鐘～七天內</li>
          <li>查詢交易時可透過交易的卡號末四碼核對</li>
        </ol>
      </Notice>
      <Input
        type="number"
        placeholder="請輸入「刷卡金額」"
        min="2"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
      />
      <Button onClick={handleSearch}>搜尋</Button>
      {message && <Message>{message}</Message>}
      {results.length > 0 && (
        <Table>
          <thead>
            <tr>
              <th>交易編號</th>
              <th>金額</th>
              <th>交易時間</th>
              <th>收款狀態</th>
              <th>末四碼</th>
            </tr>
          </thead>
          <tbody>
            {results.map((result) => (
              <tr key={result.paymentId}>
                <td>{result.paymentId}</td>
                <td>{result.amount}</td>
                <td>{result.txTime}</td>
                <td>{translateStatus(result.status)}</td>
                <td>{result.last4CC}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default SearchForm;
